import React from 'react'
import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useSyncRedemptions = ({
    onSuccess = () => {}
}={}) => {
    const [ redemptions, updateRedemptions] = React.useState([])
    const { endpoints, api } = hooks.useApi()
    const cacheKeys = hooks.useCacheKeys()

    const { toastSuccess } = hooks.useToasts({ successMessage: 'Redemptions synced!', onSuccess })

    const { clearCache } = hooks.useCache({
        onReload: toastSuccess,
        key: cacheKeys.MOBILE_IOS_REDEMPTIONS
    })
    const { toastError } = hooks.useToasts({ errorMessage: 'Error syncing redemptions'})
    

    const [saveRedemptions, { isLoading }] = useMutation(
        () => api.post(endpoints.mobileIOSRedemptions, { redemptions }),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    const setRedemptions = React.useCallback(redemptions => {
        //  add the redeemed field
        redemptions = redemptions.map(r => ({ ...r, redeemed: !r?.url?.startsWith('http') }))
        updateRedemptions(redemptions)
    }, [updateRedemptions])

    return {
        isSaving: isLoading,
        setRedemptions,
        saveRedemptions,
        canSave: !isLoading && redemptions.length
    }
} 

export default useSyncRedemptions
